import startCase from 'lodash/startCase';
import qs from 'query-string';

const CUSTOM_PARAM_PREFIX = ['perspective_', 'ps_'];
export const UTM_PARAM_IDS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
] as const;
const KNOWN_PARAM_IDS = [...CUSTOM_PARAM_PREFIX, ...UTM_PARAM_IDS];

const getQueryParameter = () => {
    const queryParams = window.location.search.substr(1);

    return _getQueryParameter(queryParams);
};

export const _getQueryParameter = (queryString: string) => {
    const params: { [key: string]: { [key: string]: string | (string | null)[] | null } } = {
        utm: {},
        custom: {},
        thirdParty: {},
        additionalTrackingTitles: {},
    };
    const queryParams = qs.parse(queryString);

    UTM_PARAM_IDS.forEach((utmParam) => {
        if (queryParams[utmParam]) {
            params.utm[utmParam] = queryParams[utmParam];
        }
    });

    CUSTOM_PARAM_PREFIX.forEach((customIdentifier) => {
        Object.keys(queryParams)
            .filter((queryParam) => {
                if (UTM_PARAM_IDS.indexOf(queryParam as (typeof UTM_PARAM_IDS)[number]) > -1) {
                    return false;
                }

                return queryParam.indexOf(customIdentifier) === 0;
            })
            .forEach((param) => {
                const name = param.substr(customIdentifier.length);
                params.custom[name] = queryParams[param];
                params.additionalTrackingTitles[name] = sanitizeTrackingTitles(name);
            });

        Object.keys(queryParams)
            .filter((queryParam) => {
                return (
                    KNOWN_PARAM_IDS.filter((checkParam) => {
                        return queryParam.indexOf(checkParam) > -1;
                    }).length === 0
                );
            })
            .forEach((queryParam) => {
                params.thirdParty[queryParam] = queryParams[queryParam];
                params.additionalTrackingTitles[queryParam] = sanitizeTrackingTitles(queryParam);
            });
    });

    const arrayToStringUTM = generateArrayToString(params.utm);
    const arrayToStringCustom = generateArrayToString(params.custom);
    const arrayToStringThirdParty = generateArrayToString(params.thirdParty);

    Object.keys(params.utm).forEach(arrayToStringUTM);
    Object.keys(params.custom).forEach(arrayToStringCustom);
    Object.keys(params.thirdParty).forEach(arrayToStringThirdParty);

    return params;
};

const generateArrayToString = (params: { [key: string]: string | (string | null)[] | null }) => {
    return (key: string) => {
        const value = params[key];

        if (Array.isArray(value)) {
            params[key] = value.join(', ');
        }
    };
};

const sanitizeTrackingTitles = (propertyName: string) => {
    const readablePropertyName = propertyName.replace(/-/g, ' ').replace(/_/g, ' ');

    return startCase(readablePropertyName);
};

export default getQueryParameter;
